import types from './usersActionsTypes';

export function usersSetUsersLoading(isLoading) {
    return { type: types.USERS_SET_USERS_LOADING, payload: isLoading };
}

export function usersSetSelectedUser(selectedUser) {
    return { type: types.USERS_SET_SELECTED_USER, payload: selectedUser };
}

export function usersSetSelectedPartner(selectedPartner) { 
    return { type: types.USERS_SET_SELECTED_PARTNER, payload: selectedPartner };
}

export function usersSetSelectedGeneralPartner(selectedGeneralPartner) {
    return { type: types.USERS_SET_SELECTED_GENERAL_PARTNER, payload: selectedGeneralPartner };
}

export function usersSetSearchUser(searchUser) {
    return { type: types.USERS_SET_SEARCH_USER, payload: searchUser };
}

export function usersSetSearchPartner(searchPartner) {
    return { type: types.USERS_SET_SEARCH_PARTNER, payload: searchPartner };
}

export function usersSetFilterPartner(partner) {
    return { type: types.USERS_SET_FILTER_PARTNER, payload: partner };
}

export function usersSetFilterApplication(application) {
    return { type: types.USERS_SET_FILTER_APPLICATION, payload: application };
}

export function usersSetModeUserModal(modeUserModal) {
    return { type: types.USERS_SET_MODE_USER_MODAL, payload: modeUserModal };
}

export function usersSetModePartnerModal(modePartnerModal) {
    return { type: types.USERS_SET_MODE_PARTNER_MODAL, payload: modePartnerModal };
}

export function usersSetModeGeneralModal(modeGeneralModal) {
    return { type: types.USERS_SET_MODE_GENERAL_MODAL, payload: modeGeneralModal };
}

export function usersSetShowUserModal(showUserModal) {
    return { type: types.USERS_SET_SHOW_USER_MODAL, payload: showUserModal };
}

export function usersSetShowPartnerModal(showPartnerModal) { 
    return { type: types.USERS_SET_SHOW_PARTNER_MODAL, payload: showPartnerModal };
}

export function usersSetShowGeneralModal(showGeneralModal) {
    return { type: types.USERS_SET_SHOW_GENERAL_MODAL, payload: showGeneralModal };
}

export function usersSetShowUsers(showUsers) {
    return { type: types.USERS_SET_SHOW_USERS, payload: showUsers };
}

export function usersSetShowEditUser(showEditUser) {
    return { type: types.USERS_SET_SHOW_EDIT_USER, payload: showEditUser };
}

export function usersSetShowUnlinkModal(showUnlinkModal) {
    return { type: types.USERS_SET_SHOW_UNLINK_MODAL, payload: showUnlinkModal };
}

export function usersSetMainEmailModal(modeUserModal) {
    return { type: types.USERS_SET_MAIN_EMAIL_MODAL, payload: modeUserModal };
}

export function usersSetMainEmailShowModal(showUserModal) { 
    return { type: types.USERS_SET_MAIN_EMAIL_SHOW_MODAL, payload: showUserModal };
}

export function usersSetMainEmailSelectedUser(selectedUser) { 
    return { type: types.USERS_SET_MAIN_EMAIL_SELECTED_USER, payload: selectedUser };
}

export function usersResetState() {
    return { type: types.USERS_RESET_STATE };
}
